<template>
  <div>
    <KnowledgeBaseEditorNav />
    <KnowledgeBaseStepper step="1" />
    <div class="container">
        <ul id="slide-out" class="sidenav sidenav-fixed">
            <li><a href="#!">First Sidebar Link</a></li>
            <li><a href="#!">Second Sidebar Link</a></li>
        </ul>
    </div>
  </div>  
</template>
<script>
import KnowledgeBaseEditorNav from "@/components/KnowledgeBaseEditorNav";
import KnowledgeBaseStepper from "@/components/KnowledgeBaseStepper";

import Sidebar from "@/components/Sidebar";
import cognitoAuth from "@/plugins/cognito";
//import GqlQuery from "@/plugins/gql";
import GqlV2Query from "@/plugins/gqlV2"

import 'isomorphic-fetch'

let gql_endpoint = process.env.GQL_ENDPOINT
let gqlv2_endpoint = process.env.GQL_V2_ENDPOINT
let read_gql_endpoint = process.env.READGQL_ENDPOINT

var draftFields = [
  "steps",
  "description",
  "title",
  "time_to_complete",
  "video_url",
  "thumbnail_url",
  "browser_title",
  "raw_url",
  "video_duration"
];

export default {
  mounted() {
    let self = this
    document.title = "fyiio | quiz editor";
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
    });
    setTimeout(function() {
      var elems = document.querySelectorAll("select");
      var instances = M.FormSelect.init(elems);
    }, 500);

    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function(err, user_attributes) {
          self.user_org = user_attributes['custom:organization_id'];
          self.user_email = user_attributes['email']
          self.user_id = user_attributes['sub']

          if (self.id) {
            //self.loadQuiz();
          } else {
            self.kbLoading = false;
          }
        });
      }
    });
  },
  updated() {},
  name: "NewQuizTemplate",
  data() {
    return {
      title: "",
      description: "",
      kb: false,
      id: this.$route.params.id,
      user_id: false,
      user_org: false,
      user_email: false,
      kbLoading: true      
    };
  },
  computed: {
    canGoNext() {
      return (
        this.title.length > 0 &&
        this.description.length > 0 &&
        this.time_to_complete
      );
    }
  },
  methods: {
    
  },
  components: {
    KnowledgeBaseEditorNav,
    KnowledgeBaseStepper
  }
};
</script>

<style scoped>
#slide-out{
    margin-top:65px
}
#toast-container {
  min-width: 10%;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  margin-top: -69px;
}
.preloader-wrapper {
  margin-top: 9px;
}
h2 {
  color: #58595b;
  font-family: Roboto;
  font-size: 24px;
  line-height: 32px;
  margin-top: 60px;
  margin-bottom: 24px;
}
button {
  margin-left: 10px;
}
.time-to-complete {
  width: 352px;
}
.time-to-complete label {
  left: 0;
}
.right.helper-text {
  text-align: right;
}
.hidden {
  display: none;
}
.loader {
  margin-top: 100px;
}
.select-wrapper input.select-dropdown,
.dropdown-content li > span {
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: lowercase;
}

.fab-next {
  float: right;
  padding-top: 42px;
  padding-bottom: 42px;
}
#description {
  margin-top: 8px;
}
</style>
<style >
.select-wrapper input.select-dropdown {
  text-transform: lowercase !important;
}
.select-wrapper .dropdown-content li > span,
ul.dropdown-content.select-dropdown li span {
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: lowercase;
}
.btn-floating.blue {
  background-color: #58595b !important;
}
.btn-floating.blue.disabled {
  background-color: #f1f1f1 !important;
}

.progress {
  background-color: #7ac7e7;
}
.progress .determinate,
.progress .indeterminate {
  background-color: #29abe1;
}
</style>


// WEBPACK FOOTER //
// src/containers/dashboard/knowledgebases/DescribeKnowledgeBase.vue